/* Hallows Night — oferta de bienvenida en una esquina.
   Pestaña fija + tarjeta. Recuerda en el navegador del visitante si ya tiene
   el código ("unlocked") o si cerró la tarjeta ("dismissed"). Sin librerías. */
(function () {
  'use strict';

  var KEY = 'hn_popup';

  function readState() {
    try {
      return JSON.parse(window.localStorage.getItem(KEY) || 'null') || {};
    } catch (e) {
      return {};
    }
  }

  function writeState(state) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(state));
    } catch (e) {
      /* modo privado o almacenamiento lleno: la oferta funciona igual, solo no recuerda */
    }
  }

  function init(root) {
    if (!root || root.hnPopupReady) return;
    root.hnPopupReady = true;

    var tab = root.querySelector('[data-hn-popup-tab]');
    var card = root.querySelector('[data-hn-popup-card]');
    var closeBtn = root.querySelector('[data-hn-popup-close]');
    var viewAsk = root.querySelector('[data-hn-popup-view="ask"]');
    var viewCode = root.querySelector('[data-hn-popup-view="code"]');
    var tabText = root.querySelector('[data-hn-popup-tab-text]');
    var copyBtn = root.querySelector('[data-hn-popup-copy]');
    var copyText = root.querySelector('[data-hn-popup-copy-text]');
    var codeEl = root.querySelector('[data-hn-popup-code]');
    var errorEl = root.querySelector('[data-hn-popup-error]');
    if (!tab || !card) return;

    var code = root.getAttribute('data-code') || '';
    var requireEmail = root.getAttribute('data-require-email') === 'true';
    var delay = parseInt(root.getAttribute('data-delay'), 10) || 0;
    var rememberDays = parseInt(root.getAttribute('data-remember'), 10) || 7;
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    var state = readState();
    var url = new URL(window.location.href);
    var timer = null;
    var cameFromForm = false;

    /* Vuelve del formulario: el correo ya está guardado → desbloquear */
    if (url.searchParams.get('hn_unlocked') === '1') {
      cameFromForm = true;
      state.unlocked = true;
      delete state.dismissedAt;
      writeState(state);
      url.searchParams.delete('hn_unlocked');
      try {
        window.history.replaceState(null, '', url.pathname + (url.search || '') + url.hash);
      } catch (e) {
        /* nada */
      }
    }

    var unlocked = state.unlocked === true || !requireEmail;

    function showView(name) {
      if (viewAsk) viewAsk.hidden = name !== 'ask';
      if (viewCode) viewCode.hidden = name !== 'code';
    }

    function paintTab() {
      if (!tabText) return;
      if (unlocked && code) {
        var label = tabText.getAttribute('data-label-unlocked') || '';
        tabText.textContent = '';
        if (label) tabText.appendChild(document.createTextNode(label + ' '));
        var strong = document.createElement('strong');
        strong.textContent = code;
        tabText.appendChild(strong);
      } else {
        tabText.textContent = tabText.getAttribute('data-label') || '';
      }
      root.classList.toggle('is-unlocked', unlocked);
    }

    function open(focusInside) {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
      showView(unlocked ? 'code' : 'ask');
      card.hidden = false;
      root.classList.add('is-open', 'is-touched');
      tab.setAttribute('aria-expanded', 'true');
      /* dos pasos para que la transición de entrada se vea */
      window.requestAnimationFrame(function () {
        card.classList.add('is-in');
      });
      if (focusInside) {
        var first = card.querySelector('input:not([type=hidden]), a, button:not([data-hn-popup-close])');
        if (first) {
          window.setTimeout(function () {
            first.focus({ preventScroll: true });
          }, 60);
        }
      }
    }

    function close(remember) {
      if (card.hidden) return;
      card.classList.remove('is-in');
      root.classList.remove('is-open');
      root.classList.add('is-touched');
      tab.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () {
        card.hidden = true;
      }, 240);
      if (remember && !unlocked) {
        state.dismissedAt = Date.now();
        writeState(state);
      }
    }

    function toggle() {
      if (card.hidden) open(true);
      else close(true);
    }

    function copyCode() {
      if (!code) return;
      var done = function () {
        copyBtn.classList.add('is-copied');
        var original = copyText ? copyText.textContent : '';
        if (copyText) copyText.textContent = root.getAttribute('data-copied-label') || original;
        window.setTimeout(function () {
          copyBtn.classList.remove('is-copied');
          if (copyText) copyText.textContent = original;
        }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () {
          selectCode();
          done();
        });
      } else {
        selectCode();
        try {
          document.execCommand('copy');
        } catch (e) {
          /* el texto queda seleccionado para copiarlo a mano */
        }
        done();
      }
    }

    function selectCode() {
      if (!codeEl || !window.getSelection) return;
      var range = document.createRange();
      range.selectNodeContents(codeEl);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }

    /* ---------- eventos ---------- */
    tab.addEventListener('click', toggle);
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        close(true);
      });
    }
    if (copyBtn) copyBtn.addEventListener('click', copyCode);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !card.hidden) {
        close(true);
        tab.focus();
      }
    });

    /* Clic fuera: cierra sin castigar (no cuenta como "no me interesa") */
    document.addEventListener('pointerdown', function (e) {
      if (card.hidden || root.contains(e.target)) return;
      close(false);
    });

    /* Editor de temas: abrir al seleccionar la sección, cerrar al soltarla */
    root.hnOpen = function () {
      open(false);
    };
    root.hnClose = function () {
      close(false);
    };

    /* ---------- estado inicial ---------- */
    paintTab();

    var cameBackWithError = !!errorEl && window.location.hash === '#hn-popup-form';

    if (cameFromForm || cameBackWithError) {
      /* Acaba de dar el correo (o el formulario devolvió un aviso): enseñar ya */
      open(false);
      return;
    }

    if (designMode) return; /* en el editor se abre al seleccionar la sección */

    if (unlocked) return; /* ya tiene el código: la pestaña basta */

    if (delay > 0) {
      var dismissedAt = state.dismissedAt || 0;
      var quietUntil = dismissedAt + rememberDays * 86400000;
      if (Date.now() > quietUntil) {
        timer = window.setTimeout(function () {
          if (document.hidden) {
            /* pestaña del navegador en segundo plano: espera a que vuelva */
            document.addEventListener(
              'visibilitychange',
              function onVisible() {
                if (document.hidden) return;
                document.removeEventListener('visibilitychange', onVisible);
                open(false);
              }
            );
            return;
          }
          open(false);
        }, delay * 1000);
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-hn-popup]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-hn-popup]');
      if (root) {
        init(root);
        if (root.hnOpen) root.hnOpen();
      }
    });
    document.addEventListener('shopify:section:select', function (e) {
      var root = e.target.querySelector('[data-hn-popup]');
      if (root && root.hnOpen) root.hnOpen();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var root = e.target.querySelector('[data-hn-popup]');
      if (root && root.hnClose) root.hnClose();
    });
  }
})();
